module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "group group--contentful group--sidebar"
  }, [_c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v(_vm._s(_vm.scrollDistance))]), _vm._v(" "), (_vm.showHighlights) ? _c('h3', {
    staticClass: "h3 fw-bold mb",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Featured content:")]) : _vm._e(), _vm._v(" "), (_vm.showHighlights) ? _c('ul', {
    staticClass: "list list--articles mt"
  }, _vm._l((_vm.highlightedArticles), function(article, index) {
    return _c('li', {
      key: article.id,
      staticClass: "list__item m0"
    }, [_c('a', {
      staticClass: "link p tdn m0 df df--column",
      on: {
        "click": function($event) {
          return _vm.navigateToArticle(article)
        }
      }
    }, [_c('h4', {
      staticClass: "h4 c-accent fw-bold m0",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v(_vm._s(article.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(article.sub))])]), _vm._v(" "), (index < _vm.highlightedArticles.length - 1) ? _c('hr', {
      staticClass: "hr"
    }) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.showHighlights) ? _c('hr', {
    staticClass: "hr mb2"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.categoriesToShow), function(category, catIndex) {
    return _c('div', {
      key: category.id,
      staticClass: "list__container"
    }, [_c('div', {
      class: [
        "list__header",
        {
          'list__header--image': category.image,
        } ],
      style: (_vm.getColour(catIndex))
    }, [_c('div', {
      staticClass: "list__inner"
    }, [(category.topics.length) ? _c('h3', {
      ref: ("scroll-" + (category.slug)),
      refInFor: true,
      staticClass: "h3 fw-medium mt0 fw-bold",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      attrs: {
        "id": category.slug
      }
    }, [_vm._v("\n          " + _vm._s(category.name) + "\n          \n        ")]) : _vm._e(), _vm._v(" "), (category.categoryDescription) ? _c('p', [_vm._v("\n          " + _vm._s(category.categoryDescription) + "\n        ")]) : _vm._e()])]), _vm._v(" "), (category.topics.length) ? _c('ul', {
      staticClass: "list list--topics"
    }, [_vm._l((category.topics), function(topic, index) {
      return _c('li', {
        key: topic.id,
        class: [
          "list__item list__item--topic",
          category.limit && category.limit <= index ?
          "list__item--hidden" :
          "" ],
        style: (_vm.getColour2(catIndex)),
        on: {
          "click": function($event) {
            return _vm.topicDetails(topic)
          }
        }
      }, [_c('div', {
        staticClass: "list__item--content"
      }, [(topic.name == '7BQRx9ZvT4Vy4ZR9l0A5iW') ? _c('div', [(category.image) ? _c('img', {
        class: ["list__image"],
        attrs: {
          "src": "client\\assets\\images\\home\\home-illustration.png",
          "alt": category.name
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h4', {
        staticClass: "h4",
        style: ({
          'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
        })
      }, [_vm._v(_vm._s(topic.name))]), _vm._v(" "), (topic.description) ? _c('p', {
        staticClass: "p"
      }, [_vm._v(_vm._s(topic.description))]) : _vm._e()])])
    }), _vm._v(" "), (category.topics.length > 3) ? _c('li', {
      class: [
        "list__item list__item--expand",
        _vm.expandedCategories[category.id] ?
        ("list__item--" + (category.topics.length % 3)) :
        "list__item--0" ]
    }, [_c('span', {
      staticClass: "c-accent fw-bold",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      on: {
        "click": function($event) {
          return _vm.expandOrCollapseCategory(category.id)
        }
      }
    }, [_vm._v("\n          See " + _vm._s(_vm.expandedCategories[category.id] ? "less" : "more") + "\n        ")])]) : _vm._e()], 2) : _vm._e()])
  }), _vm._v(" "), _c('module-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDisclaimer),
      expression: "showDisclaimer"
    }],
    attrs: {
      "modal": _vm.modalExternalData
    },
    on: {
      "close": function($event) {
        _vm.showDisclaimer = false
      }
    }
  }, [_c('template', {
    slot: "modal-footer"
  }, [_c('module-button', {
    nativeOn: {
      "click": function($event) {
        _vm.showDisclaimer = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('module-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.goToUrl.apply(null, arguments)
      }
    }
  }, [_vm._v("Yes")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "contentful__footer"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-619d78cc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/contentful/Topics.vue
// module id = 569
// module chunks = 0